module.exports = __webpack_public_path__ + "static/media/motor.3edbf3bc.svg";